(function state(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Lightbox = global.NewHomeSource.Lightbox || {};

  class State {
    /**
     * Initializes a new instance of the class.
     *
     * @constructor
     */
    constructor() {
      this.eventBus = new global.NewHomeSource.EventBus();
      this.data = {};
    }

    /**
     * Sets the options for the current instance, including the root node.
     *
     * @param {Object} options - The options object.
     * @param {HTMLElement} options.rootNode - The root DOM node to be set.
     * @returns {this} Returns the current instance for chaining.
     */
    setOptions(options) {
      this.setRootNode(options.rootNode)
        .setItems(options.lightboxDataElement);
      return this;
    }

    /**
     * Sets the root node for the lightbox state.
     *
     * @param {HTMLElement} rootNode - The root DOM node to be set.
     * @returns {this} Returns the current instance for method chaining.
     */
    setRootNode(rootNode) {
      this.data.rootNode = rootNode;
      return this;
    }

    /**
     * Parses the JSON content of the given element and sets the `items` property
     * by merging `images` and `videos` arrays from the parsed data.
     *
     * @param {HTMLElement} element - The DOM element containing JSON data in its textContent.
     * @returns {this} Returns the current instance for chaining.
     */
    setItems(element) {
      try {
        const data = JSON.parse(element.textContent);
        this.data.items = (data.images || []).concat(data.videos || []);
      } catch (error) {
        this.data.items = [];
      }
      return this;
    }

    /**
     * Finds and returns an item from the data.items array by its Id.
     *
     * @param {number|string} id - The unique identifier of the item to find.
     * @returns {Object|undefined} The item with the matching Id, or undefined if not found.
     */
    findItemById(id) {
      const number = parseInt(id, 10);
      return this.data.items.find((item) => item.Id === number);
    }

    /**
     * Retrieves the value of the specified property from the data object.
     * @param {string} property - The name of the property to retrieve.
     * @returns {*} The value associated with the specified property.
     */
    get(property) {
      return this.data[property];
    }

    /**
     * Registers an observer function to a specific topic on the event bus.
     *
     * @param {string} topic - The topic to observe for events.
     * @param {Function} observer - The callback function to be invoked when the topic is triggered.
     */
    addObserver(topic, observer) {
      this.eventBus.addObserver(topic, observer);
    }

    /**
     * Notifies all observers subscribed to a specific topic with the provided data.
     *
     * @param {string} topic - The topic to notify observers about.
     * @param {Object} data - The data to send to the observers.
     */
    notifyObservers(topic, data) {
      this.eventBus.notifyObservers(topic, data);
    }

    /**
     * Removes an observer (listener) from a specific event topic.
     *
     * @param {string} topic - The name of the event topic to remove the observer from.
     * @param {Function} observer - The observer function to be removed.
     */
    removeObserver(topic, observer) {
      this.eventBus.removeObserver(topic, observer);
    }
  }

  global.NewHomeSource.Lightbox.State = State;
}(window));
